/**
 * 辞书书籍管理 API
 *
 * 提供辞书书籍的管理操作
 */

import httpRequest from '@/utils/api'
import type {
  Book,
  CreateBookRequest,
  UpdateBookRequest,
  BatchUpdateBookRequest,
  BookListParams,
  BookListResponseData,
} from '@/types/dictation'

/**
 * API 路径枚举
 */
enum API {
  /** 书籍列表 */
  books = '/dictation-api/admin/dictation/books',
  /** 单个书籍 */
  book = '/dictation-api/admin/dictation/books/:bookId',
  /** 批量更新书籍 */
  batchUpdate = '/dictation-api/admin/dictation/books/batch-update',
}

/**
 * 获取书籍列表
 *
 * @param params 查询参数
 * @returns 书籍列表响应
 */
export const getBookListAPI = (params?: BookListParams) => {
  return httpRequest.get<BookListResponseData>({
    url: API.books,
    params,
  })
}

/**
 * 获取单个书籍详情
 *
 * @param bookId 书籍 ID
 * @returns 书籍详情响应
 */
export const getBookAPI = (bookId: number) => {
  return httpRequest.get<Book>({
    url: API.book.replace(':bookId', bookId.toString()),
  })
}

/**
 * 创建书籍
 *
 * @param data 创建请求数据
 * @returns 书籍详情响应
 */
export const createBookAPI = (data: CreateBookRequest) => {
  return httpRequest.post<Book>({
    url: API.books,
    data,
  })
}

/**
 * 更新书籍
 *
 * @param bookId 书籍 ID
 * @param data 更新请求数据
 * @returns 书籍详情响应
 */
export const updateBookAPI = (bookId: number, data: UpdateBookRequest) => {
  return httpRequest.put<Book>({
    url: API.book.replace(':bookId', bookId.toString()),
    data,
  })
}

/**
 * 删除书籍
 *
 * @param bookId 书籍 ID
 * @returns 删除响应
 */
export const deleteBookAPI = (bookId: number) => {
  return httpRequest.delete<void>({
    url: API.book.replace(':bookId', bookId.toString()),
  })
}

/**
 * 批量更新书籍（公开/免费状态）
 *
 * @param data 批量更新请求数据
 * @returns 更新响应
 */
export const batchUpdateBooksAPI = (data: BatchUpdateBookRequest) => {
  return httpRequest.patch<void>({
    url: API.batchUpdate,
    data,
  })
}

